// common/srt/ui-map.js

//
// Body Style
//
export function parseBodyStyle(style) {
   switch (style) {
      case 'standard':
         return 0;
      case 'sloping':
         return 1;
      case 'step':
      case 'step-deck':
         return 2;
      default:
         return 0;
   }
}

//
// Load Category
//
export function parseLoadType(cat) {
   switch (cat) {
      case 'mixed-freight':
         return 0;
      case 'uniform-density':
         return 1;
      case 'other':
         return 2;
      default:
         return 0;
   }
}

//
// Tyre Size Mapping: Dropdown label -> internal size key
//
const TYRE_SIZE_MAP = {
   17.5: '17.5',
   19.5: '19.5',
   22.5: '22.5',
};
export function mapTyreSize(value) {
   return TYRE_SIZE_MAP[value] || null;
}
export function tyreStringToIndex(str) {
   // MRWA uses - 0=17.5, 1=19.5, 2=22.5
   const map = { 17.5: 0, 19.5: 1, 22.5: 2 };
   return map[str] !== undefined ? map[str] : -1;
}

//
// Tyre configuration on axle
//
const TYRE_CODE_MAP = {
   0: 'single',
   1: 'wide',
   2: 'dual',
   3: 'row-of-eight',
};
export function getAllTyreConfigs() {
   return Object.values(TYRE_CODE_MAP);
}
export function mapTyreConfigCode(code) {
   return TYRE_CODE_MAP[code] || null;
}
const TYRE_CONFIG_MAP = {
   Single: 'single',
   'Wide Single': 'wide',
   Dual: 'dual',
   'Row of Eight': 'row-of-eight',
};
export function mapTyreConfig(value) {
   return TYRE_CONFIG_MAP[value] || null;
}
export function tyreConfigToIndex(config) {
   // MRWA uses - 0=single, 1=wide single, 2=dual, 3=row of eight
   const map = { Single: 0, 'Wide Single': 1, Dual: 2, 'Row of Eight': 3 };
   return map[config] !== undefined ? map[config] : -1;
}

//
// --- Axle Group Labels: Number of axles -> label
//
const AXLE_GROUP_LABELS = {
   1: 'single',
   2: 'tandem',
   3: 'tridem',
   4: 'quad',
};
export function getAxleGroupLabel(axleCount) {
   return AXLE_GROUP_LABELS[axleCount] || 'any';
}
